import React from "react";
import PropTypes from "prop-types";
import axios from "axios";
import ReactTooltip from "react-tooltip";
import Switch from "react-switch";
import LocationSelect from "../general/LocationSelect.js";
import Loading from "../general/Loading.js";
import Search from "../general/Search.js";
import GeneralTd from "../table-componets/GeneralTd.js";
import LinkTd from "../table-componets/LinkTd.js";
import ButtonTd from "../table-componets/ButtonTd.js";
import Statuses from "./Statuses";
class MyGroupLessons extends React.Component {
  state = {
    selectedLocationId: "",
    searchText: "",
    status: "current",
    page: 1,
    perPage: 25,
    totalPages: 1,
    orderBy: "start_date,start_time",
    orderDir: "ASC",
    groupLessons: [],
    user_id: this.props.currentUserId,
  };

  componentDidMount() {
    this.buildData();
  }

  buildData() {
    var that = this;
    var params = {
      page: this.state.page,
      status: this.state.status,
      per_page: this.state.perPage,
      order_by: this.state.orderBy,
      order_dir: this.state.status == "completed" ? "DESC":this.state.orderDir,
      user_id: this.props.currentUserId
    };

    if (this.state.searchText) {
      params["search"] = this.state.searchText;
    }

    if (this.state.selectedLocationId) {
      params["location_id"] = this.state.selectedLocationId;
    }
    that.setState({ loading: true });
    axios({
      method: "get",
      url: "/group_lessons.json",
      params: params,
      responseType: "json",
    })
      .then(function (response) {
        that.setState({ loading: false });
        that.setState({ error: false });
        that.setState({ groupLessons: response.data });
        that.setState({
          totalPages: Math.ceil(response.headers.total / that.state.perPage),
        });
      })
      .catch((error) => {
        that.setState({ loading: false });
        that.setState({ error: true });
        that.setState({ groupLessons: [] });
        // toastr.error("Something went wrong");
      });
  }

  newLocation(newLocation) {
    this.setState({ loading: true });
    this.setState({ selectedLocationId: newLocation });
    this.setState({ page: 1 });
    this.buildData();
  }

  newStatus = ({ target: { value } }) => {
    this.setState({ status: value, page: 1 }, () => {
      this.buildData();
    });
  };

  newSearch(newSearch) {
    this.setState({ searchText: newSearch });
    this.setState({ page: 1 });
    this.buildData();
  }

  sortData(orderBy) {
    if (orderBy == this.state.orderBy) {
      if (this.state.orderDir == "DESC") {
        this.setState({ orderDir: "ASC" });
      } else {
        this.setState({ orderDir: "DESC" });
      }
    } else {
      this.setState({ orderBy: orderBy });
      this.setState({ orderDir: "DESC" });
    }

    setTimeout(
      function () {
        this.buildData();
      }.bind(this),
      50
    );
  }

  changePage(increment) {
    var page = this.state.page + increment;
    this.setState({ page: page });
    setTimeout(
      function () {
        this.buildData();
      }.bind(this),
      50
    );
  }

  toggleColumn = (e, column) => {
    var that = this;
    that.setState({ [column]: e });
  };

  renderPagination() {
    return (
      <div>
        <p>
          {"Showing page " + this.state.page + " of " + this.state.totalPages}
        </p>
        {this.state.page == 1 && (
          <a className="btn btn-default disabled">
            <i className="material-icons progress-bar-icon">
              keyboard_arrow_left
            </i>
          </a>
        )}
        {this.state.page != 1 && (
          <a className="btn btn-default" onClick={() => this.changePage(-1)}>
            <i className="material-icons progress-bar-icon">
              keyboard_arrow_left
            </i>
          </a>
        )}
        {this.state.page < this.state.totalPages && (
          <a className="btn btn-default" onClick={() => this.changePage(1)}>
            <i className="material-icons progress-bar-icon">
              keyboard_arrow_right
            </i>
          </a>
        )}
        {this.state.page == this.state.totalPages && (
          <a className="btn btn-default disabled">
            <i className="material-icons progress-bar-icon">
              keyboard_arrow_right
            </i>
          </a>
        )}
      </div>
    );
  }

  renderBody() {
    var that = this;
    var groupLessons = [];

    _.forEach(this.state.groupLessons, function (groupLesson, index) {
      groupLessons.push(
        <tr key={index}>
          <GeneralTd fieldValue={groupLesson.location.name} />
          <GeneralTd fieldValue={groupLesson.group_lesson_program.name} />
          <GeneralTd fieldValue={groupLesson.group_lesson_level.name} />
          <GeneralTd fieldValue={groupLesson.abbreviated_days} />
          <GeneralTd fieldValue={groupLesson.member_count} />
          <GeneralTd fieldValue={groupLesson.session} />
          <GeneralTd fieldValue={groupLesson.times} />
          <GeneralTd fieldValue={groupLesson.class_code} />
          <GeneralTd fieldValue=" " noteValue={groupLesson.notes} />
          <ButtonTd
            fieldName="VIEW"
            fieldURL={"/group_lessons/" + groupLesson.id}
          />
        </tr>
      );
    });
    return <tbody>{groupLessons}</tbody>;
  }

  render() {
    var that = this;

    return (
      <div>
        <h1>My Lessons</h1>
        <div className="row">
          <LocationSelect
            locationId={this.props.locationId}
            locations={this.props.locations}
            selectClassName="col-md-3 col-xs-12"
            newLocationCallback={(newLocation) => this.newLocation(newLocation)}
          />
          <Statuses value={this.state.status} onChange={this.newStatus} />
          <Search
            newSearchCallback={(newSearch) => this.newSearch(newSearch)}
          />
        </div>
        <br />
        {that.state.groupLessons.length ? (
          <div>
            <table className="table table-clean table-white">
              <thead>
                <tr>
                  <th
                    onClick={() => this.sortData("locations-name")}
                    tabIndex="0"
                    onKeyDown={(e) => { if (e.key === "Enter") this.sortData("locations-name"); }}
                  >
                    <a
                      className="styled-link pointer-hand"
                      role="button"
                      aria-label="Sort by Location"
                    >
                      Location
                    </a>
                  </th>
                  <th
                    onClick={() => this.sortData("group_lesson_programs-name")}
                    tabIndex="0"
                    onKeyDown={(e) => { if (e.key === "Enter") this.sortData("group_lesson_programs-name"); }}
                  >
                    <a
                      className="styled-link pointer-hand"
                      role="button"
                      aria-label="Sort by Program"
                    >
                      Program
                    </a>
                  </th>
                  <th
                    onClick={() => this.sortData("group_lesson_levels-name")}
                    tabIndex="0"
                    onKeyDown={(e) => { if (e.key === "Enter") this.sortData("group_lesson_levels-name"); }}
                  >
                    <a
                      className="styled-link pointer-hand"
                      role="button"
                      aria-label="Sort by Level"
                    >
                      Level
                    </a>
                  </th>
                  <th>Days</th>
                  <th>Members</th>
                  <th
                    onClick={() => this.sortData("group_lessons-start_date")}
                    className="hidden-xs"
                    tabIndex="0"
                    onKeyDown={(e) => { if (e.key === "Enter") this.sortData("group_lessons-start_date"); }}
                  >
                    <a
                      className="styled-link pointer-hand"
                      role="button"
                      aria-label="Sort by Session Date"
                    >
                      Session
                    </a>
                  </th>
                  <th
                    onClick={() => this.sortData("group_lessons-start_time")}
                    className="hidden-xs hidden-sm"
                    tabIndex="0"
                    onKeyDown={(e) => { if (e.key === "Enter") this.sortData("group_lessons-start_time"); }}
                  >
                    <a
                      className="styled-link pointer-hand hidden-xs hidden-sm"
                      role="button"
                      aria-label="Sort by Start Time"
                    >
                      Time
                    </a>
                  </th>
                  <th className="hidden-xs hidden-sm">Class Code</th>
                  <th className="hidden-xs hidden-sm">Notes</th>
                </tr>
              </thead>
              {this.renderBody()}
            </table>
            {this.renderPagination()}
          </div>
        ) : (
          <Loading loading={this.state.loading} noDataMessage="No lessons" error = {this.state.error}/>
        )}
      </div>
    );
  }
}

MyGroupLessons.propTypes = {
  groupLessonLevels: PropTypes.array,
  locations: PropTypes.array,
  currentUserId: PropTypes.number,
};

export default MyGroupLessons;
